module.exports = __webpack_public_path__ + "static/media/brand3-large.027e9764.jpg";